// Change in Cart
function updateQuantity(line,quantity) {
  $.ajax({
      type: 'POST',
      url: '/cart/change',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function(cart) {
      },
    });
}
// ===============================================================================
// Fetch product to cart Drawer
// $(document).ready(function() {
//   $('.cv--atc').click(function(e){
//     e.preventDefault();
//     var data = $(this).parents('form').serialize();
//     var qty = 1;
    // $.ajax({
    //   type: 'POST',
    //   url: '/cart/add',
    //   data: data,
    //   dataType: 'html',
    //   success: function(response){
    //     $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
    //     $('.cart__drawer').html($(response).filter('.cart__drawer').html()).addClass('show-cart__drawer');
    //     $('.cart__drawer').addClass('show-cart__drawer');
    //     $('body').addClass('cv--show-cart__drawer');

    //     $('.cross').click(function(){
    //       $('.cart__drawer').removeClass('show-cart__drawer');
    //     });

    //   }
    // });

//   });
// });
// ===============================================================================


$(document).ready(function() {

  // Cart Drawer Open On Click Cart Icon
  $(document).on("click",".cart-full", function(e) {
    e.preventDefault();
    $('.cart__drawer').addClass('show-cart__drawer');
    $('body').addClass('cv--show-cart__drawer');
  });
  // Cart Drawer Close On Click cross Icon
  $(document).on("click",".cross",function() {
    $('.cart__drawer').removeClass('show-cart__drawer');
    $('body').removeClass('cv--show-cart__drawer');
  });
//   Close Cart Drawer click anywhere
  $(document).mouseup(function(e){
    var container = $(".cart__drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      container.show();
      $('.cart__drawer').removeClass('show-cart__drawer');
      $('body').removeClass('cv--show-cart__drawer');
    }
  });
  
});



// ===============================================================================


$(document).ready(function() {
  // Remove Item from Cart
  $(document).on("click",".cart__remove",function(e) {
    e.preventDefault();
    var itemUrl = $(this).attr('href');
    $.ajax({
      url: itemUrl,
      type:'GET',
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        $('.cart__drawer').html($(response).filter('.cart__drawer').html());  
      }
    });
  });
});

// ===============================================================================




// Change In Quantity Selector
$(document).ready(function() {

  $(document).on("click",".plus",function() {
    $(this).prev().val(+$(this).prev().val() + 1);
    var data =  $(this).parents('form').serialize();
    console.log(data);
    var quantity = $(this).prev().val();
    updateQuantity(data,quantity);
    $.ajax({
      type: 'POST',
      url: '/cart/update',
      data: data,
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        $('.cart__drawer').html($(response).filter('.cart__drawer').html());
      }
    });

  });

  $(document).on("click",".minus",function() {
    if ($(this).next().val() > 0) {
      $(this).next().val(+$(this).next().val() - 1);
      var data =  $(this).parents('form').serialize();
      var quantity = $(this).next().val();
      updateQuantity(data,quantity);
      $.ajax({
        type: 'POST',
        url: '/cart/update',
        data: data,
        dataType: 'html',
        success: function(response){
          $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
          $('.cart__drawer').html($(response).filter('.cart__drawer').html());
        }
      });
    }
  });
});

function updateCartDrawerUI() {
    
  $.ajax({
        type: 'GET',
        url: '/cart?sections=cart-drawer',
        dataType: 'html', // Change to 'html'
        success: function(sectionsResponse) {
          // console.log('sectionsResponse');
          // console.log(sectionsResponse);
            // Get the HTML for the cart drawer from the responsse
            var cartDrawerHtml = JSON.parse(sectionsResponse);
            // console.log(cartDrawerHtml['cart-drawer']);
            // console.log('cartDrawerHtml');

            // Replace the content of your cart drawer
            $('#cartdrawerContainer').html(cartDrawerHtml['cart-drawer']);

            // Show the drawer
            $('#cartdrawer').removeClass('hidden');
            if( $('#cartdrawerContainer').hasClass('hidden')) {
              $('#cartdrawerContainer').removeClass('hidden');
              $("#cartdrawer").css('right', -200);
              $("#cartdrawer").animate({right: '0px'}, 200, 'linear');
              document.documentElement.style.overflow = 'hidden';
            }

            const relativeCartElement = document.querySelector('.relative-cart-element');
            const fixedCartElement = document.querySelector('.fixed-cart-element');

            relativeCartElement.style.paddingBottom = fixedCartElement.offsetHeight + 'px';
        }
    });

}

function updateCartDrawerUINOOpen() {
    
  $.ajax({
        type: 'GET',
        url: '/cart?sections=cart-drawer',
        dataType: 'html', // Change to 'html'
        success: function(sectionsResponse) {
          // console.log('sectionsResponse');
          // console.log(sectionsResponse);
            // Get the HTML for the cart drawer from the responsse
            var cartDrawerHtml = JSON.parse(sectionsResponse);
            // console.log(cartDrawerHtml['cart-drawer']);
            // console.log('cartDrawerHtml');

            // Replace the content of your cart drawer
            $('#cartdrawerContainer').html(cartDrawerHtml['cart-drawer']);
            if( !$('#cartdrawerContainer').hasClass('hidden')) {
              $('#cartdrawer').removeClass('hidden');
              $('#cartdrawerContainer').removeClass('hidden');
              document.documentElement.style.overflow = 'hidden';
            }
        }
    });

}

function updateCartUIStatus(status) {
  const cartContainer = document.querySelector('.echCartItemsContainer');
  const cartSummary = document.querySelector('.echelon-cart-summary');
  const cartCheckout = document.querySelector('.echelon-cart-checkout');
  const cartMemberships = document.querySelector('.membershipsSelectionChange');
  switch (status) {
    case "Updated":
      if( cartContainer ) cartContainer.setAttribute('data-changing', 'false');
      if( cartSummary ) cartSummary.setAttribute('data-changing', 'false');
      if( cartCheckout ) cartCheckout.setAttribute('data-changing', 'false');
      if( cartMemberships ) cartMemberships.setAttribute('data-changing', 'false');
      break;
    case "Updating":
      if( cartContainer ) cartContainer.setAttribute('data-changing', 'true');
      if( cartSummary ) cartSummary.setAttribute('data-changing', 'true');
      if( cartCheckout ) cartCheckout.setAttribute('data-changing', 'true');
      if( cartMemberships ) cartMemberships.setAttribute('data-changing', 'true');
      break;
    default:
      console.log(`Error: ${status} is not a supported status.`);
  }

}

// document.addEventListener("la:dn:entitlements:calculated", function(event) {
//   updateCartDrawerUINOOpen();
// });

document.addEventListener("la:dn:cart:updated", function(event) {
    updateCartDrawerUINOOpen();
    setTimeout(() => {
      updateCartUIStatus('Updated');
    }, 300);
});

document.addEventListener("la:dn:cart-mutations:processed", function() {
  updateCartUIStatus('Updated');
});

document.addEventListener('DOMContentLoaded', function() {

  $('body').on('click', '.buttonclose', function() {
    $('#cartdrawer').addClass('hidden');
    $('#cartdrawerContainer').addClass('hidden');
    document.documentElement.style.overflow = '';
  });

  $('body').on('click', '.shopping-cart', function() {
    $('#cartdrawer').removeClass('hidden');
    if( $('#cartdrawerContainer').hasClass('hidden')) {
      $('#cartdrawerContainer').removeClass('hidden');
      $("#cartdrawer").css('right', -200);
      $("#cartdrawer").animate({right: '0px'}, 200, 'linear');
      document.documentElement.style.overflow = 'hidden';
    }

    const relativeCartElement = document.querySelector('.relative-cart-element');
    const fixedCartElement = document.querySelector('.fixed-cart-element');

    if(fixedCartElement){
      relativeCartElement.style.paddingBottom = fixedCartElement.offsetHeight + 'px';
    }
    updateCartUIStatus('Updated');
  });


  document.getElementById('cartdrawerContainer').addEventListener('click', function(event) {
    const cartDrawer = document.getElementById('cartdrawer');

    if (!cartDrawer.contains(event.target)) {
      $('#cartdrawer').addClass('hidden');
      $('#cartdrawerContainer').addClass('hidden');
      document.documentElement.style.overflow = '';
    }
  });

    //Deal with updating quantites
  $('body').on('change', '.drawerupdatequantity', function(e) {

    e.preventDefault(); // Prevent default link/button action

    console.log('drawerupdatequantity');

    const $selectElement = $(this);
    // 1. Get the item key and new quantity from the data attributes/value
    let itemKey = $selectElement.data('item-key'); 

    // 1.1 Check if there is a new Discount Ninja key, and is there is, use that instead
    const discountNinjaKey = $selectElement.data('la-dn-cart-item-key');
    if( discountNinjaKey && discountNinjaKey != itemKey ) { itemKey = discountNinjaKey; }

    const newQuantity = parseInt($selectElement.val(), 10);

    console.log('Item Key: ' + itemKey);
    console.log('New Quantity: ' + newQuantity);

    // Basic Validation
    if (!itemKey || isNaN(newQuantity) || newQuantity < 0) {
        console.error('Missing item key or invalid quantity.');
        return; 
    }

    // 2. Add overlay/Loading state
    // Use a container that wraps your entire drawer (e.g., if the drawer has the ID 'CartDrawer')
    const $drawerContainer = $('#CartDrawer'); 
    $drawerContainer.addClass('loading-state-active'); 
    $selectElement.prop('disabled', true);
    updateCartUIStatus('Updating');

    // 4. Update quantity using Shopify's /cart/change.js endpoint
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            'id': itemKey,      // The line item key
            'quantity': newQuantity // The new quantity (setting to 0 removes the item)
        },
        dataType: 'json',
        success: function(cart) {

            updateCartDrawerUI(); 

        },
        error: function(xhr, status, error) {

            console.error('Error updating cart:', error);
   
        },
        complete: function() {
            // 5. Remove overlay/Loading state
            $drawerContainer.removeClass('loading-state');
            //$selectElement.parent().parent().attr('changing', false);
        }
    });

    });

    $('body').on('click', '.removeMembershipFromCart', function(e) {
      e.preventDefault();

      const $selectElementDelete = $(this);
      const itemKeyDelete = $selectElementDelete.data('item-key'); 

      if (!itemKeyDelete) {
        console.error('Missing item key or invalid quantity.');
        return; 
      }
      if (itemKeyDelete.includes('40193767473265') || itemKeyDelete.includes('40193768980593')  || itemKeyDelete.includes('40441305038961')) {
        // dataToRemove = [
        //   { id: itemKeyDelete,quantity: 0 },
        //   { id: 39513568477297 ,quantity: 0 }
        // ];
        dataToRemove = {
          updates: {
            [itemKeyDelete]: 0,
            [39513568477297]: 0
          }
        };

      } else {
        // dataToRemove = [
        //   {id: itemKeyDelete,quantity: 0}
        // ];
        dataToRemove = {
          updates: {
            [itemKeyDelete]: 0
          }
        };
      }

      // console.log('dataToRemove');
      // console.log(dataToRemove);

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: dataToRemove,
        dataType: 'json',
        success: function(cart) {
          updateCartDrawerUI();
        },
        error: function(xhr, status, error) {
          console.error('Error updating cart:', error);
        }
      });

      // $.ajax({
      //   type: 'POST',
      //   url: '/cart/change.js',
      //   data: {
      //        id: itemKeyDelete,quantity: 0
      //   },
      //   dataType: 'json',
      //   success: function(cart) {

      //       updateCartDrawerUI(); 

      //   },
      //   error: function(xhr, status, error) {

      //       console.error('Error updating cart:', error);
   
      //   },
      //   complete: function() {
      //   }
      // });

    });

    $('body').on('click', '.drawerdeletequantity', function(e) {

    e.preventDefault(); // Prevent default link/button action

    // console.log('drawerdeletequantity');

    const $selectElementDelete = $(this);

    let itemKeyDelete = $selectElementDelete.data('item-key'); 
    const discountNinjaKey = $selectElementDelete.data('la-dn-cart-item-key');
    if( discountNinjaKey && discountNinjaKey != itemKeyDelete ) { itemKeyDelete = discountNinjaKey; }

    // Basic Validation
    if (!itemKeyDelete) {
        console.error('Missing item key or invalid quantity.');
        return; 
    }

    // 2. Add overlay/Loading state
    // Use a container that wraps your entire drawer (e.g., if the drawer has the ID 'CartDrawer')
    const $drawerContainerDelete = $('#CartDrawer'); 
    $drawerContainerDelete.addClass('loading-state-active'); 
    $selectElementDelete.prop('disabled', true);

    // 4. Update quantity using Shopify's /cart/change.js endpoint
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            'id': itemKeyDelete,
            'quantity': 0
        },
        dataType: 'json',
        success: function(cart) {

            updateCartDrawerUI(); 

        },
        error: function(xhr, status, error) {

            console.error('Error updating cart:', error);
   
        },
        complete: function() {
            // 5. Remove overlay/Loading state
            $drawerContainerDelete.removeClass('loading-state');
        }
    });

  });

  

  $('body').on('click', '.changemembership', function() {
    const $dropdown = $('#membershipdd');
    const isOpen = $(this).attr('data-open') === 'true';

    $dropdown.slideToggle(200);
    $(this).attr('data-open', !isOpen);
});

  $('body').on('click', '.membership-selection', function() {
    $(this).find('input[type="radio"]').prop('checked', true).trigger('change');
    updateCartUIStatus('Updating');
});

  $('body').on('change', '#membershipdd input[name="premier-membership"]', function() {
    const selectedValue = $(this).val();
    console.log('Selected:', selectedValue);
    variantid = $('.echCartItemsContainer').attr('data-product-id');
    $('li[data-product-id]').each(function() {
      // 2. Use .data() to get the value (no 'data-' prefix needed)
      variantid = $(this).data('product-id');
      // Check if the value was successfully retrieved
      if (variantid) {
        // console.log('Found Product ID:', variantid);
      } else {
        // console.log('Could not retrieve product ID for an element.');
      }
    });


    let updateData = {};

    console.log('variantid');
    console.log(variantid);

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => {
      // The API typically returns a 200 OK status on success, 
      // but the response body is often an empty JSON object {}
      if (response.ok) {
        return response.json();
      }
      // Handle HTTP errors
      throw new Error('Network response was not ok.');
    })
    .then(data => {
      if(variantid){
        console.log('1');
        addtocartwithwarranty(variantid,selectedValue, 'no');
      } else {
        console.log('2');
        switch (selectedValue) {
          case "monthly":
              membershipID = 40193761738865;
              break;
          case "annual":
              membershipID = 40193767473265;
              break;
          case "twoyear":
              membershipID = 40193768980593;
              break;
          case "annualchoice":
              membershipID = 40441305038961;
              break;
          case "monthlychoice":
              membershipID = 40441312772209;
              break;
          default:
              console.warn("Unknown membership type:", e);
              return;
      }
        //just add warranty to cart?
        c = [{ id: membershipID, quantity: 1 }];
        $.ajax({
                type: 'POST',
                url: '/cart/add.js', // Use the .js endpoint for a JSON response
                data: { items: c },
                dataType: 'json',
                success: function(response){
                  updateCartDrawerUI();
                  setTimeout(() => {
                    updateCartUIStatus('Updated');
                  }, 1000);
                }
            });
      }
    })
    .catch(error => {
      console.error('Error clearing cart:', error);
      // Handle front-end errors (e.g., network issues)
    });

    

    // if (selectedValue === 'annual') {
    //     console.log('in annual');
    //     updateData = {
    //         40193761738865: 0, // Monthly - remove
    //         40193768980593: 0, // Two-year - remove
    //         40193767473265: 1  // Annual - add
    //     };
    // } else if (selectedValue === 'twoyear') {
    //     console.log('in twoyear');
    //     updateData = {
    //         40193761738865: 0, // Monthly - remove
    //         40193768980593: 1, // Two-year - add
    //         40193767473265: 0  // Annual - remove
    //     };
    // } else if (selectedValue === 'monthly') {
    //     console.log('in monthly');
    //     updateData = {
    //         40193761738865: 1, // Monthly - add
    //         40193768980593: 0, // Two-year - remove
    //         40193767473265: 0  // Annual - remove
    //     };
    // }

    // // Safety check
    // if (!Object.keys(updateData).length) return;

    // const $drawerContainer = $('#CartDrawer');
    // $drawerContainer.addClass('loading-state');
    // console.log('Updating cart:', updateData);

    // $.ajax({
    //     type: 'POST',
    //     url: '/cart/update.js',
    //     data: { updates: updateData },
    //     dataType: 'json',
    //     success: function(cart) {
    //         updateCartDrawerUI();
    //         document.dispatchEvent(new Event('discount-ninja-cart-update'));
    //     },
    //     error: function(xhr, status, error) {
    //         console.error('Error updating cart:', error);
    //     },
    //     complete: function() {
    //         $drawerContainer.removeClass('loading-state');
    //     }
    // });
});

  /*
  $('body').on('click', '.changemembership', function() {

    //Hide cart
    $('#cartdrawer').addClass('hidden');
    $('#cartdrawerContainer').addClass('hidden');
    //Show popup
    jQuery('.popup-window[data-content="membershipIncentive"]').attr('data-visible', 'true');
    //When adding to cart, show cart
    jQuery('.link-upgrade-one').on('click', function(e) {
      e.preventDefault();
      jQuery(this).find('span').find('span').text("Please wait");
      //Remove current membership from cart
      //Remove monthly
      const updateData = {
            40564137918669: 0, // Item 1: Delete (quantity 0)
            40564140703949: 0, // Item 2: Delete (quantity 0)
            40564138213581: 1  // Item 3: Set quantity to 1
        };

        // Assuming $drawerContainer is already defined and visible
        const $drawerContainer = $('#CartDrawer'); 
        $drawerContainer.addClass('loading-state');

        $.ajax({
            type: 'POST',
            url: '/cart/update.js', // Keep the /cart/update.js endpoint for bulk updates
            data: {
                updates: updateData 
            },
            dataType: 'json',
            success: function(cart) {
                 //Close popup
                  jQuery('.popup-window[data-content="membershipIncentive"]').attr('data-visible', 'false');
                  updateCartDrawerUI();

                  document.dispatchEvent(new Event('discount-ninja-cart-update'));

            },
            error: function(xhr, status, error) {

                console.error('Error updating cart:', error);
                // Show an error message to the user here
                
            },
            complete: function() {
                
            }
        });

      


      //Close popup
      jQuery('.popup-window[data-content="membershipIncentive"]').attr('data-visible', 'false');
      updateCartDrawerUI();

    });

    jQuery('.link-upgrade-two').on('click', function(e) {
        e.preventDefault();
        jQuery(this).find('span').find('span').text("Please wait");
        // jQuery.post('/cart/update.js', {updates: {40564137918669: 0, 40564140703949: 1, 40564138213581: 0 }}); //LIVE:

        const updateData = {
            40564137918669: 0, // Item 1: Delete (quantity 0)
            40564140703949: 1, // Item 2: Delete (quantity 0)
            40564138213581: 0  // Item 3: Set quantity to 1
        };

        // Assuming $drawerContainer is already defined and visible
        const $drawerContainer = $('#CartDrawer'); 
        $drawerContainer.addClass('loading-state');

        $.ajax({
            type: 'POST',
            url: '/cart/update.js', // Keep the /cart/update.js endpoint for bulk updates
            data: {
                updates: updateData 
            },
            dataType: 'json',
            success: function(cart) {
                 //Close popup
                  jQuery('.popup-window[data-content="membershipIncentive"]').attr('data-visible', 'false');
                  updateCartDrawerUI();

                  document.dispatchEvent(new Event('discount-ninja-cart-update'));

            },
            error: function(xhr, status, error) {

                console.error('Error updating cart:', error);
                // Show an error message to the user here
                
            },
            complete: function() {
                
            }
        });

       
        
    });
  });
  */

});